import { render, staticRenderFns } from "./Discover.vue?vue&type=template&id=fa0e947a&scoped=true&"
import script from "./Discover.vue?vue&type=script&lang=js&"
export * from "./Discover.vue?vue&type=script&lang=js&"
import style0 from "./Discover.vue?vue&type=style&index=0&id=fa0e947a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa0e947a",
  null
  
)

export default component.exports